import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface IndustrySceneProps {
  // The scene is a picture, exposed as one image with this description.
  ariaLabel: string;
  // Fill classes for the soft blob and the two decorative circles.
  blobClassName: string;
  dotClassName: string;
  // The scene's own SVG shapes, drawn on a 600 x 440 canvas.
  children: ReactNode;
}

// Flat SVG frame for drawn industry hero scenes (restaurants, jewellery):
// soft blob, two circles, floor strip and a potted plant around the page's
// own shapes. Use inside <IndustryHeroVisual>.
const IndustryScene = ({
  ariaLabel,
  blobClassName,
  dotClassName,
  children,
}: IndustrySceneProps) => (
  <svg
    viewBox="0 0 600 440"
    role="img"
    aria-label={ariaLabel}
    preserveAspectRatio="xMidYMid meet"
    className="block h-auto w-full font-sans"
  >
    <path
      d="M70 250 C40 140 140 60 270 70 C420 80 560 120 548 250 C540 350 430 410 300 410 C170 410 90 360 70 250z"
      className={blobClassName}
    />
    <circle cx="520" cy="90" r="54" className={cn(dotClassName, "opacity-70")} />
    <circle cx="70" cy="360" r="34" className={cn(dotClassName, "opacity-60")} />
    <rect x="0" y="372" width="600" height="68" className="fill-line-warm" />
    {children}
    {/* Potted plant, bottom left. */}
    <g transform="translate(40 372)">
      <rect x="-14" y="0" width="28" height="30" rx="6" className="fill-line-warm" />
      <path
        d="M0 0 C-30 -30 -30 -58 -4 -70 C0 -50 6 -26 0 0"
        className="fill-tone-mint-ink"
      />
      <path
        d="M0 0 C26 -26 34 -48 14 -66 C4 -50 0 -26 0 0"
        className="fill-tone-mint-ink/60"
      />
    </g>
  </svg>
);

export default IndustryScene;
